import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DegradationParametersLoaderService {
  private degradationParametersLoaded = new Map<string, BehaviorSubject<boolean>>();

  constructor() { }

  public getDegradationParametersLoaded(regionId: string): Observable<boolean> {
    if (!this.degradationParametersLoaded.has(regionId)) {
      this.degradationParametersLoaded.set(regionId, new BehaviorSubject<boolean>(false));
    }
    return this.degradationParametersLoaded.get(regionId).asObservable();
  }

  public setDegradationParametersLoaded(regionId: string, loaded: boolean): void {
    if (!this.degradationParametersLoaded.has(regionId)) {
      this.degradationParametersLoaded.set(regionId, new BehaviorSubject<boolean>(loaded));
    } else {
      this.degradationParametersLoaded.get(regionId).next(loaded);
    }
  }

  public isDegradationParametersLoaded(regionId: string): boolean {
    if (!this.degradationParametersLoaded.has(regionId)) {
      return false;
    }
    return this.degradationParametersLoaded.get(regionId).value;
  }

  public clearDegradationParameters(regionId: string): void {
    if (this.degradationParametersLoaded.has(regionId)) {
      this.degradationParametersLoaded.get(regionId).next(false);
    }
  }

  public clearAllDegradationParameters(): void {
    this.degradationParametersLoaded.forEach(subject => subject.next(false));
  }

  public waitUntilReady(regionId: string): Promise<void> {
    if (this.isDegradationParametersLoaded(regionId)) {
      return Promise.resolve();
    }
    return new Promise<void>((resolve) => {
      const subscription = this.getDegradationParametersLoaded(regionId).subscribe((loaded) => {
        if (loaded) {
          subscription.unsubscribe();
          resolve();
        }
      });
    });
  }
}
